/**
 * Client-side unlock token after a visitor passes the home lock screen (/).
 * Whether the gate is active is controlled in Admin → Operations → Content pages → Site password lock.
 */

export const MAIN_SITE_PASSWORD = 'District2026';

const STORAGE_KEY = 'd88_main_site_unlock_v1';

export function isMainSiteUnlocked(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function setMainSiteUnlocked(): void {
  try {
    localStorage.setItem(STORAGE_KEY, '1');
    window.dispatchEvent(new Event('d88-main-site-unlocked'));
  } catch {
    /* ignore */
  }
}

export function clearMainSiteUnlock(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/** Routes inside PlatformLayout that stay reachable without the pre-launch code (auth + essential legal). */
const PUBLIC_PREFIXES = [
  '/login',
  '/register',
  '/forgot-password',
  '/reset-password',
  '/auth/callback',
  '/terms',
  '/privacy',
  '/refunds',
  '/careers',
  '/culture',
] as const;

export function isPublicMainSitePath(pathname: string): boolean {
  return PUBLIC_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}
